import { useDispatch, useSelector } from "react-redux"
import { change, initialize, isValid, reset, submit } from "redux-form"
import { application, customUserRQ, testTakerRQ } from "store/hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { saveTestTakerFetch } from "store/middlewares/testTakers.crud"
import { TestTakerRM } from "models/RM"
import { secretStorage } from "config"
import { CreateAssessmentBtn, testTakerHooks } from ".."
import { queryClient as qc } from "keys"
import { toast } from "react-toastify"
import { toastConfig } from "config"
import { allRoles, roleTypes } from "keys/roles"
import { useCallback } from "react"
import validateTestTaker from '../Validate'

const hardFields = ["tz", "first_name", "last_name", "gender", "school", "grade", "home_class"]
const softFields = ["parent_first_name", "parent_email", "parent_phone", "language", "dob",] // לדוגמה

const useSubmitBtns = () => {
    const dispatch = useDispatch()
    const queryClient = useQueryClient()
    const setAppData = application.useInitAppData()
    const resetForm = testTakerHooks.useRestForm()

    const { defaultRole } = useSelector(state => state.user)

    const setAlert = testTakerHooks.useAlert()
    const testTakers = testTakerRQ.useGetTestTakersOptions()

    const { mutateAsync: saveTestTaker, isPending: createTestTakerLoading } = useMutation({
        mutationFn: saveTestTakerFetch,
        onSuccess: async (res) => {
            const { data } = res
            const { test_taker } = data

            // כרגע הסרתי את האפשרות כי לא רציתי לאפשר למשתמש רגיל גישה לuser_roles לא ידעתי מה ההשלכות....

            // if (allRoles[defaultRole?.role_name] == roleTypes.single) {
            //     //create UserRole with new TestTaker

            //     await createUserRole({
            //         role: defaultRole.role_id,
            //         test_taker: data.test_taker.test_taker_id
            //     })
            // }

            resetForm()
            setAlert(false)

            toast('הנתונים נשמרו בהצלחה', toastConfig)
            dispatch(change("test_taker", "test_taker_id", test_taker.test_taker_id))
            dispatch(change("test_taker", "balance", test_taker.balance))

            // testTakers.refetch()
            queryClient.invalidateQueries({ queryKey: [qc.allTestTakers, qc.dashboard, qc.getWithLastAssessments] })
        },
        onError: ({ response = {} }) => {
            if (response?.data.tz == 'Tz already exists in TestTakers')
                toast.error('מספר ת"ז קיים במערכת', toastConfig)
        }
    })

    const { mutateAsync: validateTz } = customUserRQ.useValidateTz()

    const formValues = useSelector(state => state.form["test_taker"]?.values)
    const initialValues = useSelector(state => state.form["test_taker"]?.initial)
    const isFormValid = useSelector(state => isValid("test_taker")(state));

    const checkDuplicateTz = async () => {
        let isValid = await validateTz(formValues?.tz)

        if (isValid)
            return true
        return false
    }

    const save = useCallback(async () => {
        let canSave = true

        const errors = validateTestTaker(formValues || {})

        //  בדיקה אם יש שגיאה בשדה "קשיח - שדות שחייבים לקבל ערכים נכונים בשמירה"
        const hasHardErrors = Object.keys(errors).some(field => hardFields.includes(field))

        if (hasHardErrors || !formValues) {
            canSave = false
        } else if (formValues.tz !== initialValues?.tz) {
            // בדיקת כפילות ת"ז בשרת
            canSave = await checkDuplicateTz()
        }

        if (canSave) {
            const test_taker = new TestTakerRM(formValues)
            saveTestTaker(test_taker)
        } else {
            toast.error('טופס תלמיד לא חוקי', toastConfig)
            dispatch(submit("test_taker")) // השאירי כדי להציג שגיאות
        }

        // let isValid = true

        // // לא כולל את השדות של המוסד) | ארבעת שדות החובה ליצרת תלמיד
        // const { tz, first_name, last_name, gender, school, grade, school_class } = formValues || {}
        // if (!tz || !first_name || !last_name || !gender || !school || !grade || !school_class)
        //     isValid = false

        // בטלנו את הבדיקה על כל שדות הטופס
        // else if(!isFormValid || formValues == undefined)
        //     isValid = false

        // בדיקה אם השתנה התעודת זהות או שמדובר בתעודת זהות של תלמיד חדש
        // else if (formValues.tz != initialValues?.tz) {
        //     // ולידצייה של תעודת זהות בשרת - האם קיים תלמיד עם תעודה זהה
        //     isValid = await checkDuplicateTz()
        // }

        // אם הוולידצייה עברה - התלמיד נוצר
        // if (isValid) {
        //     const test_taker = new TestTakerRM(formValues)
        //     updateOrCreateTestTaker(test_taker)
        // }
        // else {
        //     // מקפיצים את הודעות השגיאה האדומות
        //     dispatch(submit("test_taker"))
        // }
    }, [formValues, initialValues])


    const submitBtns = [
        // יצירת מבדק מותאם אישית לילד - בטלנו כרגע, וגם לא נראהלי שעובד טוב כי לא היה בשימוש הרבה זמן
        // {
        //     component: "custom",
        //     customComponent: CreateAssessmentBtn,
        //     disabled: !formValues?.test_taker_id,
        //     test_taker_id: formValues?.test_taker_id,
        //     feature: "create__assessment",
        //     permissionHOC: "hidden",
        //     role: "create",
        //     variant: "white"
        // },
        {
            id: 0,
            label: "ניקוי",
            variant: "white",
            color: "light",
            action: resetForm
        },
        {
            id: 1,
            label: "שמירה",
            action: save,
            color: "thirdly4",
            variant: "regular",
            loading: createTestTakerLoading,
        }
    ]

    return submitBtns
}

export default useSubmitBtns